import { a as i, e as p, c as u, B as h, b as l } from "./abstract-base-0be59b32.js";
import { m as B } from "./lifecycle-decorators-ecc4e836.js";
import { a as m } from "./query-assigned-1d8bbbb5.js";
import { i as f } from "./utils-2e24a437.js";
var v = Object.defineProperty, y = Object.getOwnPropertyDescriptor, c = (s, o, n, e) => {
  for (var t = e > 1 ? void 0 : e ? y(o, n) : o, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (t = (e ? a(o, n, t) : a(t)) || t);
  return e && t && v(o, n, t), t;
};
const F = () => function(o) {
  let n = class extends o {
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-input - emits when a standard input event would be fired
     */
    emitInput(e, t) {
      p(this, u.INPUT, !!this.onBeaconInput && this.onBeaconInput(e, t));
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-change - emits when a standard change event would be fired
     */
    emitChange(e, t) {
      p(this, u.CHANGE, !!this.onBeaconChange && this.onBeaconChange(e, t));
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-focus - emits when a beacon form component receives focus
     */
    emitFocus(e, t) {
      p(this, u.FOCUS, !!this.onBeaconFocus && this.onBeaconFocus(e, t));
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-blur - emits when a beacon form component loses focus
     */
    emitBlur(e, t) {
      p(this, u.BLUR, !!this.onBeaconBlur && this.onBeaconBlur(e, t));
    }
    /**
     * TODO: No need
     * @param event
     * @event {BeaconEvents} beacon-event-mousedown - emits when a mousedown event would be fired
     */
    emitMousedown(e) {
      p(this, u.MOUSEDOWN, !!this.onBeaconMousedown && this.onBeaconMousedown());
    }
    connectedCallback() {
      super.connectedCallback();
    }
  };
  return c([
    i({ type: Function })
  ], n.prototype, "onBeaconChange", 2), c([
    i({ type: Function })
  ], n.prototype, "onBeaconBlur", 2), c([
    i({ type: Function })
  ], n.prototype, "onBeaconInput", 2), c([
    i({ type: Function })
  ], n.prototype, "onBeaconFocus", 2), c([
    i({ type: Function })
  ], n.prototype, "onBeaconMousedown", 2), n = c([
    B("FormEvents")
  ], n), n;
};
var _ = Object.defineProperty, C = Object.getOwnPropertyDescriptor, O = (s, o, n, e) => {
  for (var t = e > 1 ? void 0 : e ? C(o, n) : o, r = s.length - 1, a; r >= 0; r--)
    (a = s[r]) && (t = (e ? a(o, n, t) : a(t)) || t);
  return e && t && _(o, n, t), t;
};
class b extends h(l, F()) {
  constructor() {
    super(), f ? this.internals = null : this.internals = this.attachInternals ? this.attachInternals() : null;
  }
  static get formAssociated() {
    return !0;
  }
  /**
   * Implement `ElementInternals.setValidity()` with default values.
   * @param flags Custom validation flags.
   * @param message Error message used in validation.
   * @param anchor Validation target to receive focus, typically the form control element used in the shadow DOM.
   */
  setValidity(o, n, e = this.formAnchor) {
    this.internals && this.internals.setValidity(o, n, e);
  }
}
O([
  m(".form-anchor")
], b.prototype, "formAnchor", 2);
export {
  b as B
};
